<template>
  <svg class="inspection-locator" viewBox="-14 -14 148 228" aria-hidden="true">
    <g fill="none" stroke="currentColor" stroke-linejoin="round" opacity="0.55">
      <rect x="30" y="18" width="60" height="164" rx="24" stroke-width="2.5" />
      <path d="M 36 56 Q 60 46 84 56 L 80 74 Q 60 68 40 74 Z" stroke-width="1.6" />
      <path d="M 38 150 Q 60 158 82 150 L 80 138 Q 60 143 40 138 Z" stroke-width="1.6" />
      <rect x="38" y="84" width="16" height="20" rx="4" stroke-width="1.2" />
      <rect x="66" y="84" width="16" height="20" rx="4" stroke-width="1.2" />
      <rect x="38" y="116" width="44" height="18" rx="4" stroke-width="1.2" />
    </g>
    <g fill="currentColor" opacity="0.7">
      <rect x="22" y="42" width="8" height="22" rx="3" />
      <rect x="90" y="42" width="8" height="22" rx="3" />
      <rect x="22" y="140" width="8" height="22" rx="3" />
      <rect x="90" y="140" width="8" height="22" rx="3" />
    </g>

    <g :key="shotKey" class="locator-marker">
      <path :d="cone" class="locator-cone" fill="currentColor" />
      <circle
        :cx="target[0]"
        :cy="target[1]"
        r="6"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />
      <circle :cx="camera[0]" :cy="camera[1]" r="5" fill="currentColor" />
    </g>
  </svg>
</template>

<script setup lang="ts">
import type { InspectionShotKey } from '@carvia/ros-client-types';
import { computed } from 'vue';
import { getShotGuide } from './inspection-shots';

const props = defineProps<{ shotKey: InspectionShotKey }>();

const camera = computed(() => getShotGuide(props.shotKey).locator.camera);
const target = computed(() => getShotGuide(props.shotKey).locator.target);

/** Field-of-view wedge from the camera towards the target. */
const cone = computed(() => {
  const [cx, cy] = camera.value;
  const [tx, ty] = target.value;
  const angle = Math.atan2(ty - cy, tx - cx);
  const length = Math.max(Math.hypot(tx - cx, ty - cy) + 10, 24);
  const spread = 0.42;
  const point = (a: number) =>
    `${(cx + length * Math.cos(a)).toFixed(1)} ${(cy + length * Math.sin(a)).toFixed(1)}`;
  return `M ${cx} ${cy} L ${point(angle - spread)} L ${point(angle + spread)} Z`;
});
</script>

<style scoped>
.inspection-locator {
  color: var(--color-hazel-300);
  overflow: visible;
}
.locator-cone {
  opacity: 0.2;
}
</style>
